import React from 'react';
import { Route } from 'react-router-dom';
import './index.css';

import Header from './structure/Header';
import Body from './structure/Body';

import Auth from './lib/Auth';
import AuthPage from './containers/Auth';

function App () {
  if (Auth.isLoggedIn()) {
    return(
      <div>
        { !Auth.canOnlySeeOKRs() && <Route component={Header}/>}
        <Body />
      </div>
    )
  }else {
    return(
      <div>
        <Route component={AuthPage}/>
      </div>
    )
  }
}

export default App;
